// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button, Label, Input } from "@revvsales/components";

// Comonents Imports
import { DropdownSelect } from "../../../commonComponents";

// Actions Imports
import { updateDocDetails } from "../../../actions/DocumentActions";

// Internal Imports

// Destructuring

class AddRecipientsSection extends Component {
  state = {};

  render() {
    const {
      handleValue,
      sharedUsers,
      rolesOptions,
      onAddMoreUsers,
      removeRecipient,
      emailVarification,
      checkFormValidation,
      resetAddedRecipients,
    } = this.props;
    return (
      <Fragment>
        <div className="documentrecipientlist-container">
          <div
            className="docsharingpopup-sharingform-title"
            data-test="documentaddrecipients-addrecipient-label">
            Add recipients details below and choose their role (Signer or
            Reviewer)
          </div>
          <div className="docsharingpopup-sharing-form-wrapper">
            {/* ------------ Form Fields Labels Section ------------*/}
            <div className="docsharingpopup-sharingform-row ">
              <div className="recipient-email docsharingpopup-sharingform-col">
                <Label>Recipients email</Label>
              </div>
              <div className="recipient-first-name docsharingpopup-sharingform-col">
                <Label>First name</Label>
              </div>
              <div className="recipient-last-name docsharingpopup-sharingform-col">
                <Label>Last name</Label>
              </div>
              <div className="recipient-edit-access docsharingpopup-sharingform-col">
                <Label>Role</Label>
              </div>
              <div className="recipient-delete docsharingpopup-sharingform-col" />
            </div>

            {/* ------------ Form Fields Section ------------*/}
            <div className="documentaddrecipients-form-wrapper">
              {sharedUsers.map((data, i) => (
                <div className="docsharingpopup-sharingform-row form-row">
                  <div className="recipient-email docsharingpopup-sharingform-col">
                    <Input
                      style={
                        data.notValid
                          ? { borderColor: "red" }
                          : { borderColor: "" }
                      }
                      type="text"
                      className="doc-recipients-input-box"
                      value={data.user_email}
                      placeholder="Add or Search Email"
                      data-test="docsharing-popup-user-email"
                      onChange={e => handleValue(e, i, "user_email")}
                      onBlur={e => emailVarification(e, i, "user_email")}
                      autoFocus
                    />
                  </div>
                  <div className="recipient-first-name docsharingpopup-sharingform-col">
                    <Input
                      type="text"
                      className="doc-recipients-input-box"
                      disabled={data.disabled}
                      value={data.first_name}
                      placeholder="First name"
                      data-test="docsharing-user-firstname"
                      onChange={e => handleValue(e, i, "first_name")}
                    />
                  </div>
                  <div className="recipient-last-name docsharingpopup-sharingform-col">
                    <Input
                      type="text"
                      className="doc-recipients-input-box"
                      disabled={data.disabled}
                      value={data.last_name}
                      placeholder="Last name"
                      data-test="docsharing-user-lastname"
                      onChange={e => handleValue(e, i, "last_name")}
                    />
                  </div>
                  <div className="recipient-edit-access docsharingpopup-sharingform-col">
                    <DropdownSelect
                      options={rolesOptions}
                      currentValue={data.role}
                      returnValue={value => handleValue(value, i, "role")}
                    />
                  </div>

                  <div className="recipient-delete docsharingpopup-sharingform-col">
                    <span
                      className="btn-icon"
                      onClick={
                        sharedUsers && sharedUsers.length > 1
                          ? () => removeRecipient(i)
                          : resetAddedRecipients
                      }
                      onKeyPress={() => {}}
                      role="button"
                      tabIndex="0">
                      <FontAwesomeIcon icon={["far", "trash-alt"]} />
                    </span>
                  </div>
                </div>
              ))}

              {/* ------------------- Add more users and share section ------------------- */}
              <div className="docsharingpopup-sharingform-footer">
                <div className="docsharingpopup-addmoreuser-btn">
                  <Tooltip placement="right" overlay="Add more users">
                    <Button
                      className="revv-btn-secondary"
                      data-test="docsharing-popup-add-btn"
                      onClick={
                        !checkFormValidation() ? () => {} : onAddMoreUsers
                      }>
                      <i className="plusiconadd">
                        <FontAwesomeIcon icon={["far", "plus"]} className="" />{" "}
                      </i>
                      &nbsp; Add recipients
                    </Button>
                  </Tooltip>
                </div>
              </div>

              {/* ---------------- Invite Section ----------------  */}
              {/* {sharedUsers.length > 0 && (
                <div className="documentrecipientlist-invitebtn-wrapper">
                  <Button
                    className="btn btn-primary invitebtn"
                    disabled={!this._checkFormValidation()}
                    // isLoading={showBtnLoader}
                    onClick={this._share}>
                    INVITE
                  </Button>
                </div>
              )} */}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  updateDocDetails,
};

export default connect(
  null,
  mapDispatchToProps,
)(AddRecipientsSection);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AddRecipientsSection/index.js